/* eslint-disable react/no-unescaped-entities */
import React, {Fragment, memo} from 'react';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import dynamic from 'next/dynamic';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'));
import {clients} from '@/util/contents/home-data';
import {spacing} from '@/styles/tokens';

const clientBoxWrapperSx = {marginBottom: spacing[60]} as const;

const clientGridContainerSx = {alignItems: 'center', textAlign: 'center'} as const;

const clientImageBoxSx = {
    '@media (max-width:430px)': {
        '& img': {width: '100% !important', height: 'auto !important'}
    }
} as const;

const Clients = () => {
    return (
        <MUIBox sx={clientBoxWrapperSx}>
            <MUIContainer>
                <MUIBox className="spectrum-header-wrapper solutions">
                    <MUITypography className="spectrum-heading color-black">Clients we've served</MUITypography>
                    <MUIBox className="divder-wrapper">
                        <hr className="divider-line" />
                    </MUIBox>
                </MUIBox>
                <MUIGrid container spacing={6} sx={clientGridContainerSx}>
                    {clients?.map((data: any, index: number) => (
                        <Fragment key={index}>
                            <MUIGrid item xs={6} sm={4} md={3} lg={3}>
                                <MUIBox sx={clientImageBoxSx}>
                                    <DisplayImage src={data.src} alt={data.alt} priority={false} />
                                </MUIBox>
                            </MUIGrid>
                        </Fragment>
                    ))}
                </MUIGrid>
            </MUIContainer>
        </MUIBox>
    );
};
export default memo(Clients);
